import { ImportExportHistoriesColumn } from '@/features/import_export_histories/type';
import { GetImportExportHistoriesListSortBy } from 'ap-openapi';
import { SortOrder, SorterResult } from 'antd/es/table/interface';

/** convert sort_by(API/state) to sortOrder(display) */
export const sortByToSortOrder = (
  sortBy: string | undefined
): { field: string; order: SortOrder } | undefined => {
  if (!sortBy) return undefined;
  if (sortBy === 'submitted_at:asc')
    return { field: 'executed_at', order: 'ascend' };
  if (sortBy === 'submitted_at:desc')
    return { field: 'executed_at', order: 'descend' };
  if (sortBy === 'completed_at:asc')
    return { field: 'completed_at', order: 'ascend' };
  if (sortBy === 'completed_at:desc')
    return { field: 'completed_at', order: 'descend' };
  return undefined;
};

/** convert table sorter(column click) to sort_by(API/state) */
export const sorterToSortBy = (
  sorter:
    | SorterResult<ImportExportHistoriesColumn>
    | SorterResult<ImportExportHistoriesColumn>[]
): GetImportExportHistoriesListSortBy | undefined => {
  if (Array.isArray(sorter)) return undefined;
  if (!sorter.order || !sorter.field) return undefined;

  const field = String(sorter.field);
  const order = sorter.order === 'ascend' ? 'asc' : 'desc';

  if (field === 'executed_at') {
    return order === 'asc' ? 'submitted_at:asc' : 'submitted_at:desc';
  }
  if (field === 'completed_at') {
    return order === 'asc' ? 'completed_at:asc' : 'completed_at:desc';
  }
  return undefined;
};
